import { useAccountStore } from '@/app/modules/account';
import type { Guard } from './interfaces';

export function createNotElephantGuard(redirect = '/'): Guard {
  return async () => {
    const store = useAccountStore();
    await store.fetch();
    return !store.isElephant || redirect;
  };
}
